exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-4f3df061] {\n  font-size: 0.9rem;\n  height: 35px;\n  background-color: #b3c2c4;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\nselect[data-v-4f3df061]:focus {\n  background-color: #d0d9da;\n  border-color: #b3c2c4;\n  box-shadow: 0 0 0 0.1rem #799498;\n}", ""]);

// exports
